import * as React from 'react'
import { Text } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../StyleComponents'
import {
  BulletList,
  BulletListItem,
  ImageContainer,
  NumericList,
} from '../../styles'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'
import { MotorcycleSafetyDasherSafetyImage } from '../../images/MotorcycleSafetyDasherSafetyImage'

export const MotorcycleDasherSafetySection = () => {
  return (
    <SectionContainer>
      <ImageContainer>
        <MotorcycleSafetyDasherSafetyImage />
      </ImageContainer>
      <Text styles={Text.Styles.Bold32}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__online_safety_course__dasher_safety
        )}
      </Text>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__environmental_risks
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__covid19000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__in_order_to_protect_the_safety_of_all_users_of001
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__we_also_encourage_you_to_follow_the_below_recommendations002
        )}
      </ContentText>
      <NumericList>
        {[
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__regularly_wash_your_hands_with_soap_and_water_or_use003,
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__keep_surfaces_including_your_hot_bag_and_vehicle_clean_by004,
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__cover_your_coughs_or_sneezes_with_a_tissue_and_stay005,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </NumericList>

      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__slips_falls000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__the_majority_of_falls_occur_from_slipping_or_tripping_on001
        )}
      </ContentText>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__take_your_time_and_dont_rush_when_leaving_or_returning,
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__pay_close_attention_to_the_surfaces_that_you_are_walking,
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__always_wear_enclosed_shoes_with_good_grip_and_laces_that,
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__be_on_the_lookout_for_any_warnings_or_signs_that,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>

      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__animals000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__some_consumers_may_have_dogs_or_other_animals_that_could001
        )}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__antisocial_behaviour
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__the_safety_of_dashers_merchants_and_consumers_that_use_the000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__creating_an_unsafe_environment_for_anyone_on_the_platform_can001
        )}
      </ContentText>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__violence_or_inappropriate_behaviour_including_abusive_language_exhibiting_objectively_unsafe,
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__use_of_alcohol_and_drugs_dashing_while_under_the_influence,
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__discrimination_or_harassment_doordash_prohibits_discrimination_and_harassment_by_or,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__if_at_any_point_in_time_you_feel_unsafe_or
        )}
      </ContentText>
      <NumericList>
        {[
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__put_your_well_being_first_and_remove_yourself_from_the000,
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__if_you_feel_you_may_be_in_danger_or_the001,
          i18nKeys.safetyCourse_motorcycle_step5__dasher_safety__when_you_feel_it_is_safe_enough_to_do_so002,
        ].map(key => (
          <BulletListItem mb={'XSmall'} key={key}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </NumericList>
    </SectionContainer>
  )
}
